import React, { useState, useEffect } from 'react';
import { makeStyles, Button, Paper, Switch, FormGroup, FormControlLabel  } from '@material-ui/core';
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import { apiDataService } from './../../Services/apiDataService';

/* Imported front-end */
import DeleteDialog from './../Api/DeleteDialog';
import ApiDevexGrid from '../Api/ApiDevexGrid';
import AddEditDrawer from './../Api/AddEditDrawer';

/* Imported icons */
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';





export default function ApiScopesPage() {
    const classes = useStyles();
    const [crudTitle, setTitle] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [reload, setReload] = useState(false);
    const [rows, setRows] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [enabled, setEnabled] = useState(true);

    const columns = [
        { name: 'id', title: 'ID', type:"label", shown: true, helper: false, helperText: ''},
        { name: 'enabled', title: 'Enabled', type:"label", shown: true, helper: false, helperText: ''},
        { name: 'name', title: 'Name', type:"text", shown: true, helper: false, helperText: ''},
        { name: 'displayName', title: 'Display name', type:"text", shown: true, helper: false, helperText: ''},
        { name: 'description', title: 'Description', type:"text", shown: true, helper: false, helperText: ''},
    ];

    useEffect(() => {
        if (reload === true){
            setReload(false);
        }


        let mounted = true
        if(enabled === true){
            apiDataService.getApis().then(o => {
            if (mounted) {
                if(JSON.stringify(rows) !== JSON.stringify(o)){
                    if(enabled === true){
                        setRows(o);
                    }else{
                        console.log('Loop?')
                        let trueApis = o.filter(x => x.enabled === true);
                        setRows(trueApis);
                    }
                }
            }
        }).catch((error) => {toast.error(error, {position: toast.POSITION.TOP_CENTER})}) 
        }
       
    },[rows, reload]);


    const addRow = () => {
        openDrawer("Add", true, null);
    };
    
    const editRow = (id) => {
        openDrawer("Edit", true, id);
    };
    const deleteRow = (id) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };
    const openDrawer = (title, open, id) => {
        setTitle(title);
        setDrawerOpen(open);
        setEditId(id);
      }

      
    const handleClose = () => {
        setOpenDeleteDialog(false);
    };

    const handleDelete = (id) => {
        setOpenDeleteDialog(false);
        apiDataService.deleteApi(id).then(() => setReload(true)).catch((error) => {
            toast.error(error, {
              position: toast.POSITION.TOP_CENTER
            });
        });
    };

    const handleChange = (event) => {
        if(event.target.checked === true){
            setEnabled(true);
            apiDataService.getApis().then(o => {
                setRows(o);
            })

        }else{
            setEnabled(false);
            apiDataService.getApis().then(o => {
                let trueApis = o.filter(x => x.enabled === true);
                setRows(trueApis);
            })
        }
      };
      

    const ActionFormatter = (row) => (
        <React.Fragment>
            <IconButton onClick={() => editRow(row.row.id)} title="Edit row">
            <EditIcon />
            </IconButton>
            <IconButton onClick={() => deleteRow(row.row.id)}>
                <DeleteIcon />
            </IconButton>
        </React.Fragment>
    );
    return (
        <div className={classes.container}>
            <div className={classes.buttonWell}> 
                        <div className={classes.rowFlex}>
                        <NavLink className={classes.navButton} to="/index">
                                <Button className={classes.backButton} color="primary"  variant="contained" ><ArrowBackIcon></ArrowBackIcon> Back</Button>
                            </NavLink>
                            <Button className={classes.addButton} color="primary"  variant="contained" onClick={() => addRow()}>
                                <AddIcon /> Add
                            </Button>
                        
                        </div>
                        <Paper className={classes.paper}>
                        <div className={classes.toggleRow}>
                                <FormGroup className={classes.formGroup}>
                                    <FormControlLabel  onChange={handleChange} control={<Switch defaultChecked />} label="Show disabled" />
                                </FormGroup>
                            </div>
                            <ApiDevexGrid classname={classes.table} columns={columns} data={rows} hasActions={true} ActionFormatter={ActionFormatter} addRow={addRow}></ApiDevexGrid>
                        </Paper>
                        <AddEditDrawer setReload={setReload} rows={rows} title={crudTitle} openDrawer={openDrawer} drawerOpen={drawerOpen} editId={editId} columns={columns}></AddEditDrawer>
                        <DeleteDialog open={openDeleteDialog} id={deleteId} handleClose={handleClose} handleDelete={handleDelete}></DeleteDialog>
            </div>
        </div>
  );
}

const useStyles = makeStyles({
    container: {
        position: 'relative',
        width: '100%',
        display: 'block',
        justifyContent: 'center',
        textAlign: 'center',
        verticalAlign: 'center'
    },
    toggleRow:{
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
    },
    buttonWell: {
        marginTop: '25px',
        marginRight: '5%',
        marginLeft: '5%',        
    },
    rowFlex: {
        display: 'flex',
        marginTop: '10px',
        marginBottom: '10px',
        justifyContent: 'space-between',
    },
    backButton: {
        marginLeft: '10px',
    },
    addButton: {
        
    },

    paper: {
        padding: '5px',
        height: '60%',
        width : "100%",
        overflow: "auto",
    },
    navButton: {
        textDecoration: 'none',
        alignContent: 'center',
    },
    styledButton: {
        marginTop: '25px',
        alignContent: 'center',
        marginBottom: '25px',
        fontSize: '20px !important'
    },

});